<template>
  <div id="page-forms">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <template>
            <v-card flat>
              <v-card-text>
                <v-toolbar color="white" dark flat dense cad>
                  <v-toolbar-title class="indigo--text"
                    >Datos de contrato</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
                <template>
                  <v-form>
                    <v-container>
                      <v-layout>
                        <v-flex>
                          <!-- INICIO DATOS DE PROVEEDOR -->
                          <data-proveedor
                            v-if="show1 == true"
                            :tipeView="tipeView"
                          ></data-proveedor>
                          <data-proveedor
                            v-if="show2 == true"
                            :tipeView="tipeView"
                            :contratoId="contratoId"
                          ></data-proveedor>
                          <!-- TERMINO DATOS DE PROVEEDOR -->
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </template>
                <v-spacer></v-spacer>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-card>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import DataProveedor from "@/modules/configuration/contrato/ContratoData.vue";
Vue.use(VeeValidate);
export default {
  components: {
    DataProveedor,
  },
  data() {
    return {
      tipeView: "",
      loading: false,
      show1: false,
      show2: false,
    };
  },
  mounted() {},
  created() {
    this.tipeView = this.$route.params.tipeView;
    if (this.tipeView == "crear") {
      this.show1 = true;
    }
    if (this.tipeView == "modifica") {
      this.show2 = true;
    }
    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
  },
  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
